import React from 'react';
import { SESSimg, SFSPSimg } from '../../../images/btnIcons';
import LanguageTranslater from "../../HOC/LanguageTranslater";
import './PlanCodeDrawer.css'
import { Button } from 'unified-ui-components-library';

const PlanCodeDrawer = ({ handleState, translate }) => {
    const productName = localStorage.getItem('productName')
    return (
        productName === 'Max Life Smart Secure Easy Solution' ?
            <div className="actionsheet-ovrlay" >
                <div className="plancode-drawer-cntnr sess" >
                    <div className="img-cntnr" >
                        <img src={SESSimg} alt="plan_code_img" />
                    </div>
                    <div className="txt-cntnr">
                        <p className="heading-plancode" >{translate("Max Life Smart Secure Easy Solution")}</p>
                        <div className="txt-content" >
                            <p className="sm-planecode-heading" >{translate("above_combination_of")}</p>
                            <p className="para" >
                                <span className="para-heading"> Max Life Smart Secure Plus Plan:</span>
                                is a pure protection policy. In case of the policyholder’s untimely death within the policy period,
                                a specific sum assured amount would be paid to the insured person’s nominee by Max Life Insurance.
                            </p>
                            <p className="para" >
                                <span className="para-heading">Accidental Cover:</span>
                                on death due to an accident,
                                100% of accident cover sum assured will be payable as lump sum in addition to the death benefit sum assured.
                            </p>
                            <p className="para" >
                                <span className="para-heading">Critical Illness & Disability Rider: </span>
                                pays you an additional lump sum amount if you are diagnosed with a critical illness or disability.
                            </p>
                        </div>
                    </div>
                    <div className='thank-you-button'>
                        <Button
                            onClick={handleState}
                            buttonType='secondary'
                            width='264'
                        >
                            Okay
                        </Button>
                    </div>
                </div>
            </div> : <div className="actionsheet-ovrlay" >
                <div className="plancode-drawer-cntnr sfsps" >
                    <div className="img-cntnr" >
                        <img src={SFSPSimg} alt="plan_code_img" />
                    </div>
                    <div className="txt-cntnr">
                        <p className="heading-plancode" >Max Life Smart Flexi Protect Solution</p>
                        <div className="txt-content" >
                            <p className="sm-planecode-heading" >The above is a combination of:</p>
                            <p className="para" >
                                <span className="para-heading">Max Life Flexi Wealth Plus Plan:</span>
                                has protection and savings benefit. You can invest into equity and debt fund options. It also allows you to make partial withdrawals from your accumulated fund value once the initial lock-in period of five years is over.
                            </p>
                            <p className="para" >
                                <span className="para-heading">Critical Illness & Disability Rider:</span>
                                pays you an additional lump sum amount if you are diagnosed with a critical illness or disability.
                            </p>

                        </div>
                    </div>
                    <div className='thank-you-button'>
                        <Button
                            onClick={handleState}
                            buttonType='secondary'
                            width='264'
                        >
                            Okay
                        </Button>
                    </div>
                </div>
            </div>
    )
}


export default LanguageTranslater(PlanCodeDrawer)